var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResultsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8674 46.5C36.5692 46.5 44.4341 38.6351 44.4341 28.9333C44.4341 19.2315 36.5692 11.3667 26.8674 11.3667C17.1656 11.3667 9.30078 19.2315 9.30078 28.9333C9.30078 38.6351 17.1656 46.5 26.8674 46.5Z",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4346 43.6676L51.9697 59.2028C52.4378 59.6709 53.0723 59.9333 53.7336 59.9333C54.3949 59.9333 55.0294 59.6709 55.4975 59.2028L57.1364 57.5639C57.6045 57.0958 57.8669 56.4613 57.8669 55.8C57.8669 55.1387 57.6045 54.5042 57.1364 54.0361L41.6012 38.501",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8828 8.76164C32.4028 7.77584 29.6985 7.23334 26.8672 7.23334C25.1415 7.23334 23.4634 7.43484 21.8545 7.8151",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1625 12.6067C40.0258 11.6105 38.7848 10.7322 37.458 9.9882",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 31.218C5.56438 33.8975 6.35385 36.5686 7.69202 39.0941C8.48665 40.5935 9.43215 41.9616 10.4996 43.1892",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4574 3.90187C16.8273 4.82877 13.5052 6.52447 10.6738 8.80504",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6454 3.1279C24.7072 3.17233 23.7823 3.26533 22.874 3.4069",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8607 3.4069C29.9266 3.26223 28.9749 3.16717 28.0098 3.1248",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9411 4.73887C35.0752 4.41337 34.1865 4.13334 33.2803 3.90187",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7842 7.16513C40.0609 6.70116 39.2776 6.23203 38.5078 5.84143",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5343 31.8804C52.6438 30.9132 52.7006 29.9295 52.7006 28.9333C52.7006 24.1645 51.409 19.6974 49.1553 15.8637",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.667 36.1894C51.853 35.5518 52.0152 34.9039 52.1527 34.2467",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1338 53.4161C35.8365 53.1784 36.5267 52.9118 37.2005 52.6173",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 54.4381C31.6985 54.3254 32.3878 54.1849 33.0667 54.0185",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6172 51.1149C17.4912 53.4337 22.0234 54.7667 26.8666 54.7667C27.529 54.7667 28.1862 54.7419 28.8361 54.6923",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39258 45.9079C8.47138 47.1448 9.66591 48.2773 10.9596 49.29",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1553 24.5809C15.4655 20.7535 18.4922 17.6256 22.4374 16.2481",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4336 28.9333C13.4336 28.2751 13.4811 27.6282 13.5721 26.9948",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74256 23.9454C5.36643 25.5471 5.16699 27.217 5.16699 28.9333",
    stroke: "#002145",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIcon);
export default __webpack_public_path__ + "static/media/no_results_icon.7644eebf13c96f5ef0f76c464a8adb54.svg";
export { ForwardRef as ReactComponent };